import { Route } from 'react-router-dom';
import { ManageRoute } from '../components/auth/ManageRoute.js';
import { DispatchPage, SchedulePage } from '../lazyPages.js';

/* ===========================================================================
 * THE PLAN — who works when (the weekly schedule) and where (the morning
 * dispatch). The two rows the Attendance group lists as "the plan, not the
 * register", in one fragment for the reason `approvalDoorRoutes.tsx` gives
 * (App.tsx is size debt behind a ratchet); spliced in as `{PLAN_ROUTES}`.
 *
 * Each route carries the same `permission` and `feature` as its nav row in
 * `navGroups.ts`; `routeGates.test.tsx` fails when the two disagree.
 * ======================================================================== */
export const PLAN_ROUTES = (
  <>
    <Route
      path="schedule"
      element={
        <ManageRoute permission="schedules.view" feature="shifts">
          <SchedulePage />
        </ManageRoute>
      }
    />
    <Route
      path="dispatch"
      element={
        <ManageRoute permission="dispatch.view" feature="dispatch">
          <DispatchPage />
        </ManageRoute>
      }
    />
  </>
);
